import { MAP_SELECTED_COLOR, MAP_MUTED_COLOR } from '../../../constants/scoreScale';

export const SELECTED_MAP_COLOR = MAP_SELECTED_COLOR;
export const MUTED_MAP_COLOR = MAP_MUTED_COLOR;

/**
 * Once an element is selected, it stays purple and every other spatial
 * element becomes neutral grey. With no selection, normal category colours
 * remain unchanged.
 */
export function getMapElementColor(selectedElement, element, normalColor) {
  if (!selectedElement) return normalColor;
  return selectedElement.id === element.id ? SELECTED_MAP_COLOR : MUTED_MAP_COLOR;
}

export function isMutedMapElement(selectedElement, element) {
  return Boolean(selectedElement && selectedElement.id !== element.id);
}
